import type { JobStatus } from '@stamp/merch';

const statusClassMap: Record<JobStatus, string> = {
  brief_draft: 'status-badge--draft',
  generating: 'status-badge--generating',
  artwork_review: 'status-badge--review',
  artwork_approved: 'status-badge--approved',
  product_configuration: 'status-badge--processing',
  mockups_processing: 'status-badge--processing',
  merch_review: 'status-badge--review',
  sample_required: 'status-badge--action',
  ready_to_publish: 'status-badge--approved',
  publishing: 'status-badge--generating',
  published: 'status-badge--published',
  action_required: 'status-badge--action',
  rejected: 'status-badge--rejected',
  archived: 'status-badge--archived',
};

const labelMap: Record<JobStatus, string> = {
  brief_draft: 'Brief Draft',
  generating: 'Generating',
  artwork_review: 'Artwork Review',
  artwork_approved: 'Artwork Approved',
  product_configuration: 'Product Config',
  mockups_processing: 'Mockups Processing',
  merch_review: 'Merch Review',
  sample_required: 'Sample Required',
  ready_to_publish: 'Ready to Publish',
  publishing: 'Publishing',
  published: 'Published',
  action_required: 'Action Required',
  rejected: 'Rejected',
  archived: 'Archived',
};

interface StatusBadgeProps {
  status: JobStatus;
  size?: 'sm' | 'md';
}

export function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const cls = statusClassMap[status] ?? 'status-badge--draft';
  const label = labelMap[status] ?? status.replace(/_/g, ' ');
  return (
    <span className={`status-badge ${cls}`} style={size === 'sm' ? { fontSize: '0.65rem', padding: '2px 8px' } : undefined}>
      <span className="status-badge__dot" />
      {label}
    </span>
  );
}
